export default __webpack_public_path__ + "static/media/geotag.84b7db2c.svg";